import { useCallback } from 'react';

import { Trash } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import { ControlledConfirmationPopover } from '@/components/ConfirmationPopover';
import { useAppAlert } from '@Components/AppAlert';
import { getInfo } from '@Components/Grid/components/Table/formatters';
import { useGrid } from '@Components/Grid/context';

import { TEMPLATES } from './TypeFormatter';

export default function DeleteEntity({ info }) {
  const { row } = getInfo(info)
  const { definitions: { entityName }, events: { handleDeleteEntry } } = useGrid()
  const { handleSuccess } = useAppAlert()

  const handleSubmit = useCallback(async () => {
    await handleDeleteEntry(row)
    handleSuccess(`${entityName} deleted!`)
  }, [row, handleDeleteEntry, handleSuccess, entityName])

  return <>
    <ControlledConfirmationPopover
      target={<DefaultTooltip content='Delete' side='left'><Trash size={16} /></DefaultTooltip>}
      title={<span>Delete {entityName.toLowerCase()} <i>{`[#${row.id}] ${TEMPLATES[row.typeTemplate]}`}</i></span>}
      onSubmit={handleSubmit}
    >
      <strong className='mb-1'>Are you sure you want do this?</strong>
    </ControlledConfirmationPopover>
  </>
}
